import React from "react";
import { Details } from "../../models/Details";
import "../../style/style.scss";
import "./Gender.scss";

import maleImage from '../../assets/male.png';
import femaleImage from '../../assets/female.png';
import { AnalyticsApi } from "../../api/user";


export enum GenderE {
	Male,
	Female,
}
interface GenderProp {
	detail: Details;
	valueSelected(response?: any): void;
}

const Gender: React.FC<GenderProp> = ({ detail, valueSelected }): JSX.Element => {
	const [gender, setGender] = React.useState(-1);

	const valueClicked = (gender: GenderE) => {
		AnalyticsApi.logEvent('Gender Selected');
		setGender(gender);
		detail.setGender(gender);

		setTimeout(function () {
			valueSelected(gender);
		}, 500);


	};

	React.useEffect(() => {
		if (typeof detail.gender !== "undefined") {
			setGender(detail.gender);
		}
	}, []);

	return (
		<div className="content">
			<div className="button-row">
				<div
					className={`gender ${gender === GenderE.Male ? "selected" : ""}`}
					onClick={(e) => valueClicked(GenderE.Male)}
				>
					<img
						src={maleImage}
						id="male"
						className="sexImage"
						alt="male"
					></img>
				</div>
				<div
					className={`gender ${gender === GenderE.Female ? "selected" : ""}`}
					onClick={(e) => valueClicked(GenderE.Female)}
				>
					<img
						src={femaleImage}
						id="female"
						className="sexImage"
						alt="female"
					></img>
				</div>
			</div>

			<div className="button-row">
				<div className="gender">
					<button className="greenButton" onClick={(e) => valueClicked(GenderE.Male)}>
						Male
					</button>
				</div>
				<div className="gender">
					<button className="greenButton" onClick={(e) => valueClicked(GenderE.Female)}>
						Female
					</button>
				</div>
			</div>
		</div>
	);
};

export default Gender;
